import React from "react";
import MainLayout from "../../layouts/MainLayout";
import {useTranslation} from "react-i18next";
import "./styles.css";

const Page404 = () => {
    const [t] = useTranslation("common");
    return (
        <MainLayout>
            <div className="backgroundImg404">
                <div className="page404">
                    <h1>{t("common.pageNotFound")}</h1>
                </div>
            </div>
        </MainLayout>
    );
}

export default Page404;
